import Format from '../Format'
import { defineMessages, useIntl } from 'react-intl'
import { Flex, Text, Heading } from '@homebotapp/hb-react-component-catalog'

export const MSG = defineMessages({
  rate: {
    id: 'Homeowner.interest.refinance.apr',
    defaultMessage: 'APR'
  }
})

export interface APRProps {
  value: number
}

export const APR = ({ value }) => {
  const intl = useIntl()

  if (!value) return null

  return (
    <Flex align='center' direction='column'>
      <Heading mb={-1} size='3xs' as='h6' variant='eyebrow' fontWeight='regular'>
        {intl.formatMessage(MSG.rate)}
      </Heading>
      <Text size='2xs' as='span'>
        <Format.Rate value={value} />
      </Text>
    </Flex>
  )
}
